const API_BASE_URL = (
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? 'http://localhost:5068' : '')
).replace(/\/+$/, '');

function getErrorMessage(data) {
  if (data && typeof data === 'object' && typeof data.message === 'string') {
    return data.message;
  }

  return 'Sizden Gelenler yuklenirken beklenmeyen bir hata olustu.';
}

export async function fetchPublicTestimonials(take = 12) {
  const query = new URLSearchParams();
  query.set('take', String(take));

  const response = await fetch(`${API_BASE_URL}/api/public/testimonials?${query.toString()}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    let errorData = null;
    try {
      errorData = await response.json();
    } catch {
      errorData = null;
    }
    throw new Error(getErrorMessage(errorData));
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
}
